// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ImageViewer_overlay__sJith","imageWrapper":"ImageViewer_imageWrapper__mOXDO","closeButton":"ImageViewer_closeButton__kW6kT"};